/**
 * @generated SignedSource<<bc227035e643bd2377577c536a6d74ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MainLocaleQuery$variables = Record<PropertyKey, never>;
export type MainLocaleQuery$data = {
  readonly currentStore: {
    readonly locale: string;
    readonly timezone: string;
  } | null;
};
export type MainLocaleQuery = {
  response: MainLocaleQuery$data;
  variables: MainLocaleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locale",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MainLocaleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MainLocaleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7693bba70190a985b7d67ae8620769d2",
    "id": null,
    "metadata": {},
    "name": "MainLocaleQuery",
    "operationKind": "query",
    "text": "query MainLocaleQuery {\n  currentStore {\n    locale\n    timezone\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "53f2bb37b1c67383130443b2b38bb493";

export default node;
